var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5832 14.4167C15.9165 14.7501 15.9165 15.2501 15.5832 15.5834C15.4165 15.7501 15.2498 15.8334 14.9998 15.8334C14.7498 15.8334 14.5832 15.7501 14.4165 15.5834L9.99984 11.1667L5.58317 15.5834C5.4165 15.7501 5.24984 15.8334 4.99984 15.8334C4.74984 15.8334 4.58317 15.7501 4.4165 15.5834C4.08317 15.2501 4.08317 14.7501 4.4165 14.4167L8.83317 10.0001L4.4165 5.58341C4.08317 5.25008 4.08317 4.75008 4.4165 4.41675C4.74984 4.08341 5.24984 4.08341 5.58317 4.41675L9.99984 8.83341L14.4165 4.41675C14.7498 4.08341 15.2498 4.08341 15.5832 4.41675C15.9165 4.75008 15.9165 5.25008 15.5832 5.58341L11.1665 10.0001L15.5832 14.4167Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_416_10457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5832 14.4167C15.9165 14.7501 15.9165 15.2501 15.5832 15.5834C15.4165 15.7501 15.2498 15.8334 14.9998 15.8334C14.7498 15.8334 14.5832 15.7501 14.4165 15.5834L9.99984 11.1667L5.58317 15.5834C5.4165 15.7501 5.24984 15.8334 4.99984 15.8334C4.74984 15.8334 4.58317 15.7501 4.4165 15.5834C4.08317 15.2501 4.08317 14.7501 4.4165 14.4167L8.83317 10.0001L4.4165 5.58341C4.08317 5.25008 4.08317 4.75008 4.4165 4.41675C4.74984 4.08341 5.24984 4.08341 5.58317 4.41675L9.99984 8.83341L14.4165 4.41675C14.7498 4.08341 15.2498 4.08341 15.5832 4.41675C15.9165 4.75008 15.9165 5.25008 15.5832 5.58341L11.1665 10.0001L15.5832 14.4167Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_416_10457)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D0D2D6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d378754cc8632a1149370ae7ea366ff6.svg";
export { ForwardRef as ReactComponent };